module.exports = __webpack_public_path__ + "static/designEditMenu-7986bab9ed956fc2878dc3fcaa04e15b.png";